import dayjs from 'dayjs';
import dayjsUTC from 'dayjs/plugin/utc';
import dayjsTimezone from 'dayjs/plugin/timezone';
import dayjsCustomParseFormat from 'dayjs/plugin/customParseFormat';
import dayjsRelativeTime from 'dayjs/plugin/relativeTime';
import dayjsLocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjsIsSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import dayjsIsBetween from 'dayjs/plugin/isBetween';
import dayjsIsTomorrow from 'dayjs/plugin/isTomorrow';
import dayjsIsToday from 'dayjs/plugin/isToday';

// Dayjs plugins
dayjs.extend(dayjsUTC);
dayjs.extend(dayjsTimezone);
dayjs.extend(dayjsCustomParseFormat);
dayjs.extend(dayjsRelativeTime);
dayjs.extend(dayjsLocalizedFormat);
dayjs.extend(dayjsIsSameOrBefore);
dayjs.extend(dayjsIsBetween);
dayjs.extend(dayjsIsTomorrow);
dayjs.extend(dayjsIsToday);

export default dayjs;
